import React from 'react';
import { FaQuestionCircle, FaEnvelope, FaTools, FaBookOpen, FaUsers, FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

function Help() {
  return (
    <div className="help-page">
      <Helmet>
        <title>Help - darsgah-e-ahlebait</title>
        <meta name="description" content="Get help and support for using darsgah-e-ahlebait platform." />
      </Helmet>
      <div className="container">
        <h2 className="mb-4 text-center fw-bold">Help & Support</h2>
        <div className="row g-4 mb-4">
          <div className="col-md-8">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq1">
                  <button className="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                    <FaQuestionCircle className="me-2 text-primary" /> How do I submit a paper?
                  </button>
                </h2>
                <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="faq1" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Go to the <a href="/submit">submission page</a>, follow the instructions, and upload your manuscript using the provided template.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq2">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                    <FaQuestionCircle className="me-2 text-primary" /> What file formats are accepted?
                  </button>
                </h2>
                <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="faq2" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    We accept Word (.docx) and PDF files for initial submissions.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq3">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                    <FaQuestionCircle className="me-2 text-primary" /> How long does peer review take?
                  </button>
                </h2>
                <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="faq3" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    The review process typically takes 4-6 weeks. You will be notified by email of any updates.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq4">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                    <FaQuestionCircle className="me-2 text-primary" /> How do I contact the editorial team?
                  </button>
                </h2>
                <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="faq4" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Email <a href="mailto:drsyedrizwanabbas@gmail.com">drsyedrizwanabbas@gmail.com</a> for editorial queries or support or call 03444244544.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq5">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                    <FaQuestionCircle className="me-2 text-primary" /> How can I become a reviewer?
                  </button>
                </h2>
                <div id="collapse5" className="accordion-collapse collapse" aria-labelledby="faq5" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Send your CV and research interests to <a href="mailto:drsyedrizwanabbas@gmail.com">drsyedrizwanabbas@gmail.com</a>.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq6">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                    <FaQuestionCircle className="me-2 text-primary" /> Where can I find author templates?
                  </button>
                </h2>
                <div id="collapse6" className="accordion-collapse collapse" aria-labelledby="faq6" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Visit the <a href="/resources">Resources</a> page for downloadable templates and forms.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="faq7">
                  <button className="accordion-button collapsed fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                    <FaQuestionCircle className="me-2 text-primary" /> How do I reset my password?
                  </button>
                </h2>
                <div id="collapse7" className="accordion-collapse collapse" aria-labelledby="faq7" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    Use the password reset link on the <a href="/login">login page</a> or contact support if you need further assistance.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card shadow-sm border-0 mb-4">
              <div className="card-body text-center">
                <FaEnvelope className="mb-2 text-primary" size={32} />
                <h5 className="fw-bold">Contact Support</h5>
                <p>If you need help, email <a href="mailto:drsyedrizwanabbas@gmail.com">drsyedrizwanabbas@gmail.com</a> or call 03444244544 or use our <a href="/contact">contact form</a>. We aim to respond within 2 business days.</p>
              </div>
            </div>
            <div className="card shadow-sm border-0 mb-4">
              <div className="card-body">
                <h5 className="fw-bold text-success mb-2"><FaTools className="me-2" />Troubleshooting Tips</h5>
                <ul>
                  <li>Clear your browser cache if you experience loading issues.</li>
                  <li>Ensure your files are under the maximum upload size (10MB).</li>
                  <li>Check your spam folder for notification emails.</li>
                  <li>For technical issues, include screenshots and error messages in your support email.</li>
                </ul>
              </div>
            </div>
            <div className="card shadow-sm border-0 mb-4">
              <div className="card-body">
                <h5 className="fw-bold text-info mb-2"><FaBookOpen className="me-2" />Getting Started</h5>
                <ol>
                  <li>Register for an account or log in.</li>
                  <li>Read the <a href="/resources">submission guidelines</a>.</li>
                  <li>Prepare your manuscript using the template.</li>
                  <li>Submit your work and track progress online.</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 mb-4">
          <div className="col-md-12">
            <div className="card shadow-sm border-0 bg-light">
              <div className="card-body d-flex align-items-center">
                <FaUsers className="me-3 text-primary" size={32} />
                <div>
                  <h5 className="fw-bold mb-1">Support Flow</h5>
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <span className="badge bg-primary bg-opacity-10 text-primary"><FaArrowRight className="me-1" />Visit Help Page</span>
                    <span className="badge bg-info bg-opacity-10 text-info"><FaArrowRight className="me-1" />Read FAQ</span>
                    <span className="badge bg-warning bg-opacity-10 text-warning"><FaArrowRight className="me-1" />Contact Support</span>
                    <span className="badge bg-success bg-opacity-10 text-success"><FaCheckCircle className="me-1" />Get Solution</span>
                  </div>
                  <p className="mb-0 mt-2">We’re here to help authors, reviewers, and readers succeed!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help; 